module.exports = __webpack_public_path__ + "img/Black-Box-img-en-m.46542587.png";